import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSocketConnexion } from '../../hooks/socket';
import { AuthStatus } from '../../interfaces/session';
import { Loading } from '../utils/Loading';

interface PrivateRouteProps {
  redirectPath?: string,
  authStatus: AuthStatus,
}

const PrivateRoute = ({ redirectPath = '/login', authStatus }: PrivateRouteProps) => {
  useSocketConnexion();
  const { pathname, search, hash } = useLocation();
  if (authStatus === AuthStatus.Out) {
    const target = `${pathname}${search}${hash}`;
    const skip = target === '/' || pathname.startsWith('/login') || pathname.startsWith('/logout');
    const redirection = skip ? redirectPath! : `${redirectPath}?redirect=${encodeURIComponent(target)}`;
    return <Navigate to={redirection} replace />;
  }
  if (authStatus === AuthStatus.Loading) {
    return <Loading />;
  }
  return <Outlet />;
};

export default PrivateRoute;
